import classNames from 'classnames'
import React, { ReactNode } from 'react'

// Constants
import { ALIGNMENT_TYPES } from './grid.constants'

export interface ColumnProps {
  children: ReactNode
  justifiedContent?: ALIGNMENT_TYPES
  className?: string
}

const Column = (props: ColumnProps) => {
  const className = classNames('d-flex flex-d--row', props.className, {
    [`justify-content--${props.justifiedContent}`]: !!props.justifiedContent,
  })
  return <div className={className}>{props.children}</div>
}

export default Column
